import React from 'react'
import { Link } from 'react-router-dom'
import { useTranslation } from "react-i18next";

const PasswordSent = () => {
  const {t} = useTranslation();
  return (
    <div className='resetPassword'>
        <div className='container'>
            <div className='row'>
                <div className='col-lg-5 col-md-6 mx-auto'>
                    <div className='box-passwordSent'>
                        <h1 className='title'>{t('login.password-sent-successfully')}</h1>
                        <p className='info'>{t('login.your-password-has-been-changed-successfully-please')}</p>
                        <Link to="/login" className='btn-blue text-center d-block w-100'>{t('login.sign-in')}</Link>
                    </div>
                </div>
            </div>
        </div>
    </div>
  )
}

export default PasswordSent